import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      maxWidth: 752,
    },
    deleteButton: {
      marginLeft: 2,
      marginRight: 2,
    },
    demo: {
      backgroundColor: theme.palette.background.paper,
    },
    title: {
      margin: theme.spacing(4, 0, 2),
      textAlign: "center",
    },
    profile: {
      height: "100%",
      width: "100%",
      objectFit: "cover",
    },
  })
);
